import debounce from 'lodash/debounce'
import getUrl from 'lib/url'
import { stringify } from 'querystring'
import fetch from 'lib/decorated-fetch'
const fetchResult = debounce((keyword, setState) => {
  const params = {
    offset: 0,
    limit: 30,
    sort: 'count',
    user_id: '109005472317',
    support_type: 2,
    _: Date.now(),
    keyword: undefined,
  }
  if (keyword) {
    params.keyword = keyword
  }
  fetch(
    getUrl(
      `/motor/ugc_activity/v1/${
        keyword ? 'search_activity' : 'get_list'
      }/?${stringify(params)}`
    )
  )
    .then(json => {
      setState({
        keyword,
        topicList:
          json.data?.[keyword ? 'activity_info' : 'activity_list'] || [],
        loaded: true,
      })
    })
    .catch(() => {
      console.error('获取话题列表失败，请重试')
    })
}, 300)

export default fetchResult
